import * as React from 'react';
import { connect } from 'react-redux';
import { User } from 'oidc-client';
import { AppState } from '../../../store';
import { Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

type NoPermissionsProps = {
    user: User;
}

class NoPermissions extends React.Component<NoPermissionsProps> {
      public render() {
        return (
        <React.Fragment>
                <Row>
                    <Col>
                        <Card className="panel">
                            <Card.Header>
                                <Row>
                                    <Col md={12}>
                                        <h3>No Permissions</h3>
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Card.Body>
                                <div>
                                    Your user account does not have required permissions to view this page or document.<br />
                                    To get access or if there is a problem please contact <a href='mailto:dsa@allcovered.com'>dsa@allcovered.com</a>.
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
        </React.Fragment>
        );
      }

}

function mapStateToProps(state: AppState) {
    return {
        user: state.oidc.user,
    };
}


export default connect(
    mapStateToProps
)(NoPermissions as any);